import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tag, Descriptions, Table } from 'antd';
import {
  StyledModal,
  StyledModalHeader,
  MainButton,
} from '../../../../common/form/FormElements.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import { Spinner } from '../../../../common/index.jsx';
import { useGetChangeRequestQuery } from '../../../../../redux/services/ing_projects_change_requests.jsx';

const getApprovalTag = (value, t) => {
  if (value === 1) {
    return <Tag color="green">{t('Schválené')}</Tag>;
  }
  if (value === 2) {
    return <Tag color="red">{t('Zamietnuté')}</Tag>;
  }
  return <Tag color="orange">{t('Čaká na schválenie')}</Tag>;
};

const IpChangeRequestDetailModal = ({
  changeRequestId,
  visible,
  onClose,
  onApprove,
  onReject,
}) => {
  const { t } = useTranslation();

  const { data: changeRequest, isLoading } = useGetChangeRequestQuery(
    changeRequestId,
    { skip: !changeRequestId, refetchOnMountOrArgChange: true },
  );

  if (!visible) return null;

  return (
    <StyledModal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      destroyOnClose
    >
      <StyledModalHeader>{t('Detail žiadosti o zmenu projektu')}</StyledModalHeader>

      {isLoading || !changeRequest ? (
        <Spinner />
      ) : (
        <>
          <Descriptions
            bordered
            column={1}
            size="small"
            style={{ marginBottom: 16 }}
          >
            <Descriptions.Item label={t('Študent')}>
              {changeRequest.student?.person?.full_name || '–'}
            </Descriptions.Item>
            <Descriptions.Item label={t('Pôvodný projekt')}>
              {changeRequest.original_project?.name || '–'}
            </Descriptions.Item>
            <Descriptions.Item label={t('Nový projekt')}>
              {changeRequest.new_project?.name || '–'}
            </Descriptions.Item>
            <Descriptions.Item label={t('Študijný program')}>
              {changeRequest.study_program?.name || '–'}
            </Descriptions.Item>
          </Descriptions>

          <Table
            title={() => t('Stav schválení')}
            bordered
            size="small"
            pagination={false}
            style={{ marginBottom: 16 }}
            rowKey="role"
            columns={[
              {
                title: t('Rola'),
                dataIndex: 'role',
              },
              {
                title: t('Meno'),
                dataIndex: 'name',
              },
              {
                title: t('Stav'),
                dataIndex: 'status',
                render: (value) => getApprovalTag(value, t),
              },
            ]}
            dataSource={[
              {
                role: t('Garant pôvodného projektu'),
                name: changeRequest.original_guarantor?.full_name || '–',
                status: changeRequest.approved_original,
              },
              {
                role: t('Garant nového projektu'),
                name: changeRequest.new_guarantor?.full_name || '–',
                status: changeRequest.approved_new,
              },
              {
                role: t('Garant študijného programu'),
                name: changeRequest.program_guarantor?.full_name || '–',
                status: changeRequest.approved_program,
              },
            ]}
          />

          {changeRequest.can_approve && (
            <FormButtonsContainer>
              <MainButton
                danger
                onClick={() => {
                  onReject?.(changeRequest.id);
                  onClose();
                }}
              >
                {t('Zamietnuť')}
              </MainButton>
              <MainButton
                onClick={() => {
                  onApprove?.(changeRequest.id);
                  onClose();
                }}
              >
                {t('Schváliť')}
              </MainButton>
            </FormButtonsContainer>
          )}
        </>
      )}
    </StyledModal>
  );
};

IpChangeRequestDetailModal.propTypes = {
  changeRequestId: PropTypes.number,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
};

export default IpChangeRequestDetailModal;
